class TBProductBundle extends HTMLElement {

  #listeners;

  #requests = new Map();

  #submitting = false;



  connectedCallback() {

    this.#listeners?.abort();

    this.#listeners = new AbortController();

    const options = { signal: this.#listeners.signal };

    const choices = this.querySelector('[data-bundle-choices]');

    if (!choices) return;

    choices.hidden = false;

    this.addEventListener('input', event => {

      if (event.target.matches('[data-bundle-quantity]')) this.#updateButton();

    }, options);

    this.addEventListener('change', event => {

      if (event.target.matches('[data-bundle-choices] input[type="radio"]')) this.#toggle();

      if (event.target.matches('[data-bundle-quantity]')) this.#updateButton();

      if (event.target.matches('[data-bundle-option]')) this.#updateRow(event.target.closest('[data-bundle-row]'), event.target.dataset.optionPosition);

    }, options);

    this.addEventListener('click', event => {

      const option = event.target.closest('[data-bundle-value]');

      if (option) {

        const row = option.closest('[data-bundle-row]');

        const select = row.querySelector(`select[data-option-position="${option.dataset.optionPosition}"]`);

        select.value = option.dataset.bundleValue;

        select.dispatchEvent(new Event('change', { bubbles: true }));

        return;

      }

      const step = event.target.closest('[data-quantity-step]');

      if (step) {

        const input = this.querySelector('[data-bundle-quantity]');

        if (Number(step.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();

        this.#updateButton();

        return;

      }

      if (!event.target.closest('[data-bundle-add]')) return;

      event.preventDefault();

      this.#addPair();

    }, options);

    this.#toggle();

    window.Shopify?.PaymentButton?.init?.();

  }



  disconnectedCallback() {

    this.#listeners?.abort();

    for (const request of this.#requests.values()) request.abort();

    this.#requests.clear();

  }



  #toggle() {

    const selected = this.querySelector('[data-bundle-choices] input:checked');

    const count = selected?.value === 'single' ? 1 : Number(selected?.dataset.bundleCount || 2);

    const pair = count > 1;

    this.dataset.mode = pair ? 'pair' : 'single';

    this.dataset.bundleCount = String(count);

    this.querySelector('[data-single-quantity]').hidden = pair;

    this.querySelectorAll('[data-bundle-row]').forEach((row, index) => { row.hidden = index >= count; });

    this.#syncQuantity();

    this.#syncSinglePrice();

    this.querySelector('[data-bundle-add]').textContent = pair

      ? (this.dataset.addCountLabel?.replace('__COUNT__', String(count)) || this.dataset.addPairLabel)

      : this.dataset.addSingleLabel;

    this.#error('');

    this.#updateButton();

  }



  #variant(row) {

    try { return JSON.parse(row.querySelector('[data-bundle-variant]').textContent); }

    catch { return null; }

  }



  #lines() {

    const lines = new Map();

    const variants = new Map();

    for (const row of this.querySelectorAll('[data-bundle-row]')) {

      if (row.hidden) continue;

      const variant = this.#variant(row);

      if (!variant?.id || !variant.available) throw new Error(this.dataset.unavailableMessage);

      const id = String(variant.id);

      variants.set(id, variant);

      const line = lines.get(id) || { merchandiseId: id, quantity: 0 };

      const quantity = this.dataset.mode === 'single' ? Number(this.querySelector('[data-bundle-quantity]').value) : 1;

      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(this.dataset.quantityMessage);

      line.quantity += quantity;

      lines.set(id, line);

    }

    for (const [id, line] of lines) {

      const variant = variants.get(id);

      if (line.quantity < variant.min || (variant.max != null && line.quantity > variant.max) || line.quantity % variant.step !== 0) throw new Error(this.dataset.quantityMessage);

    }

    return [...lines.values()];

  }



  #syncQuantity() {

    const variant = this.#variant(this.querySelector('[data-bundle-row]'));

    const input = this.querySelector('[data-bundle-quantity]');

    const min = variant?.min || 1, step = variant?.step || 1;

    input.min = String(min);

    input.step = String(step);

    if (variant?.max != null) input.max = String(variant.max); else input.removeAttribute('max');

    let value = Number(input.value);

    if (!Number.isSafeInteger(value) || value < min) value = min;

    if (variant?.max != null) value = Math.min(value, variant.max);

    if (value % step !== 0) value = Math.max(min, Math.floor(value / step) * step);

    input.value = String(value);

  }



  #syncSinglePrice() {

    if (this.dataset.mode !== 'single') return;

    const row = this.querySelector('[data-bundle-row]');

    const template = row.querySelector('[data-bundle-native-price]');

    const price = template?.content.querySelector('[ref="priceContainer"]');

    const section = this.closest('.shopify-section');

    if (!price || !section) return;

    section.querySelectorAll('product-price').forEach(component => {

      if (component.dataset.productId !== this.dataset.productId) return;

      const container = component.querySelector('[ref="priceContainer"]');

      if (container) container.replaceChildren(...[...price.childNodes].map(node => node.cloneNode(true)));

    });

    const mediaId = this.#variant(row)?.media;

    const gallery = section.querySelector('media-gallery');

    const slideshow = gallery?.querySelector('slideshow-component');

    if (mediaId && typeof slideshow?.select === 'function') {

      const slides = [...gallery.querySelectorAll('slideshow-slides > slideshow-slide')];

      const index = slides.findIndex(slide => slide.querySelector(`[data-media-id="${mediaId}"]`));

      if (index >= 0) slideshow.select(index, undefined, { animate: false });

    }

  }



  #syncExpressCheckout(valid) {

    const wrapper = this.querySelector('[data-bundle-express]');

    if (!wrapper) return;

    wrapper.hidden = !valid;

    if (!valid) return;

    const lines = this.#lines();

    const variant = wrapper.querySelector('[data-express-variant]');

    const quantity = wrapper.querySelector('[data-express-quantity]');

    const extra = wrapper.querySelector('[data-express-additional-items]');

    for (const [input, value] of [[variant, lines[0].merchandiseId], [quantity, String(lines[0].quantity)]]) {

      if (input.value !== value) {

        input.value = value;

        input.dispatchEvent(new Event('change', { bubbles: true }));

      }

    }

    const signature = JSON.stringify(lines.slice(1));

    if (extra.dataset.items !== signature) {

      extra.replaceChildren();

      lines.slice(1).forEach((line, index) => {

        for (const [attribute, value] of [['id', line.merchandiseId], ['quantity', line.quantity]]) {

          const input = document.createElement('input');

          input.type = 'hidden';

          input.name = `shopify-additional-items[${index + 1}][${attribute}]`;

          input.value = String(value);

          extra.append(input);

        }

      });

      extra.dataset.items = signature;

      extra.dispatchEvent(new Event('change', { bubbles: true }));

    }

  }



  #updateButton() {

    const button = this.querySelector('[data-bundle-add]');

    let valid = !this.#submitting && this.#requests.size === 0;

    try { this.#lines(); } catch { valid = false; }

    button.disabled = !valid;

    button.setAttribute('aria-busy', String(this.#submitting));

    this.#syncExpressCheckout(valid);

    this.#updatePrice();

  }



  #discountPercent(count) {

    if (count < 2) return 0;

    const group = this.dataset.discountGroup || 'none';

    if (group === 'apparel') return Math.min(count, 4) * 5;

    return group === 'footwear' ? 5 : 0;

  }



  #updatePrice() {

    const rows = [...this.querySelectorAll('[data-bundle-row]')];

    const selectedCount = this.dataset.mode === 'single'

      ? Number(this.querySelector('[data-bundle-quantity]').value)

      : Number(this.dataset.bundleCount || 2);

    const summary = this.querySelector('[data-bundle-summary]');

    summary.hidden = !Number.isSafeInteger(selectedCount) || selectedCount < 2;

    const label = this.querySelector('[data-summary-label]');

    if (label) label.textContent = this.dataset.totalLabel.replace('__COUNT__', String(selectedCount));

    const money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });

    const shippingThreshold = Number(this.dataset.freeShippingThreshold);
    const qualifiesForFreeShipping = total => Number.isInteger(shippingThreshold) && shippingThreshold > 0 && total >= shippingThreshold;
    const discountLabel = percent => this.dataset.discountLabel.replace('__PERCENT__', String(percent));
    const singlePrice = this.querySelector('[data-bundle-single-price]');
    const firstVariant = this.#variant(rows[0]);
    if (singlePrice) {
      singlePrice.setAttribute('aria-busy', String(this.#requests.has(rows[0])));
      singlePrice.textContent = Number.isInteger(firstVariant?.price)
        ? money.format(firstVariant.price / 100)
        : this.dataset.unavailableMessage;
    }

    const singleShipping = this.querySelector('[data-single-shipping]');
    if (singleShipping) singleShipping.hidden = this.#requests.has(rows[0]) || !Number.isInteger(firstVariant?.price) || !qualifiesForFreeShipping(firstVariant.price);
    this.querySelectorAll('[data-bundle-price]').forEach(element => {

      const isSummary = element.hasAttribute('data-summary-price');

      const count = isSummary ? selectedCount : Number(element.dataset.tierCount || 2);

      const sameVariant = isSummary && this.dataset.mode === 'single';

      const applicable = sameVariant ? rows.slice(0, 1) : rows.slice(0, count);

      const variants = applicable.map(row => this.#variant(row));

      const valid = Number.isSafeInteger(count) && count > 0 && applicable.length === (sameVariant ? 1 : count)

        && applicable.every(row => !this.#requests.has(row))

        && variants.every(v => v?.available && Number.isInteger(v.price) && v.price >= 0);

      const percent = this.#discountPercent(count);
      const badge = element.closest('.tb-offer')?.querySelector('[data-tier-badge]');
      const summaryShipping = isSummary ? this.querySelector('[data-summary-shipping]') : null;
      if (badge) badge.textContent = discountLabel(percent);
      if (summaryShipping) summaryShipping.hidden = true;
      element.hidden = !valid;

      if (!valid) return;

      const grouped = new Map();

      for (const variant of variants) {

        const line = grouped.get(String(variant.id)) || { price: variant.price, quantity: 0 };

        line.quantity += sameVariant ? count : 1;

        grouped.set(String(variant.id), line);

      }



      let original = 0, discount = 0;

      for (const line of grouped.values()) {

        const subtotal = line.price * line.quantity;

        original += subtotal;

        discount += Math.floor(line.price * percent / 100) * line.quantity;

      }

      element.querySelector('[data-bundle-original]').textContent = money.format(original / 100);

      element.querySelector('[data-bundle-total]').textContent = money.format((original - discount) / 100);
      const comparison = element.querySelector('s');
      if (comparison) comparison.hidden = discount === 0;
      const freeShipping = qualifiesForFreeShipping(original - discount);
      if (badge && freeShipping) badge.textContent = this.dataset.discountWithShippingLabel.replace('__PERCENT__', String(percent));
      if (summaryShipping) summaryShipping.hidden = !freeShipping;

    });

  }



  async #updateRow(row, position) {

    this.#requests.get(row)?.abort();

    const controller = new AbortController();

    this.#requests.set(row, controller);

    row.setAttribute('aria-busy', 'true');

    this.#error('');

    this.#updateButton();

    const url = new URL(this.dataset.productUrl, location.origin);

    const root = window.Shopify?.routes?.root || '/';

    if (!url.pathname.startsWith(root)) url.pathname = root.replace(/\/$/, '') + url.pathname;

    url.search = location.search;

    url.searchParams.delete('variant');

    url.searchParams.set('view', 'tb-bundle-variant');

    url.searchParams.set('option_values', [...row.querySelectorAll('[data-bundle-option]')].map(select => select.value).join(','));

    try {

      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });

      if (!response.ok) throw new Error(this.dataset.errorMessage);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');

      const content = html.querySelector('[data-bundle-row-content]');

      if (!content || this.#requests.get(row) !== controller) throw new Error(this.dataset.errorMessage);

      row.querySelector('[data-bundle-row-content]').replaceWith(content);

      const selector = this.dataset.mode === 'single' ? `[data-bundle-value][data-option-position="${CSS.escape(position)}"][aria-pressed="true"]` : `select[data-option-position="${CSS.escape(position)}"]`;

      row.querySelector(selector)?.focus();

      if (row === this.querySelector('[data-bundle-row]')) {

        this.#syncQuantity();

        this.#syncSinglePrice();

      }

      if (!this.#variant(row)?.available) this.#error(this.dataset.unavailableMessage);

    } catch (error) {

      if (controller.signal.aborted) return;

      row.querySelector('[data-bundle-variant]').textContent = '{}';

      this.#error(error.message || this.dataset.errorMessage);

    } finally {

      if (this.#requests.get(row) === controller) {

        this.#requests.delete(row);

        row.removeAttribute('aria-busy');

        this.#updateButton();

      }

    }

  }



  async #addPair() {

    if (this.#submitting || this.#requests.size) return;

    this.#error('');

    let lines;

    try { lines = this.#lines(); } catch (error) { this.#error(error.message); return; }

    this.#submitting = true;

    this.#updateButton();

    try {

      const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines.map(line => ({ id: line.merchandiseId, quantity: line.quantity })) }) });

      const result = await response.json();

      if (!response.ok) throw new Error(result.description || this.dataset.errorMessage);

      location.assign(this.dataset.cartUrl);

    } catch (error) {

      this.#error(error.message || this.dataset.errorMessage);

    } finally {

      this.#submitting = false;

      this.#updateButton();

    }

  }



  #error(message) {

    const target = this.querySelector('[data-bundle-error]');

    target.textContent = message;

    target.hidden = !message;

  }

}



if (!customElements.get('tb-product-bundle')) customElements.define('tb-product-bundle', TBProductBundle);

